import { createActionCreator } from 'utils';

const { createAction } = createActionCreator('Statistics');

export const fetchSalesReport = createAction('Fetch sales report');
export const fetchSalesReportDone = createAction('Fetch sales report done');
